import { signOutWithEntra } from '../../Authentication/entraLogout';
import config from './Amplify';
import {
    getAccessToken,
    getIdToken,
    getUserIfSignedIn,
    signOut,
} from './amplifyAuthAdapter';

// TODO: concat this two Class into one
class GMGAuth {
    /** @type {GMGHostedAuth | undefined} */
    static #instance = undefined;

    /** @returns {GMGHostedAuth} */
    static getInstance() {
        if (!GMGAuth.#instance) {
            GMGAuth.#instance = new GMGHostedAuth();
        }
        return GMGAuth.#instance;
    }

    async getUserIfSignedIn() {
        return await getUserIfSignedIn();
    }
}

class GMGHostedAuth extends GMGAuth {
    async getAccessToken() {
        return await getAccessToken();
    }

    async getIdToken() {
        return await getIdToken();
    }

    /**
     * Signs the user out of Cognito and clears the hosted-UI cookies.
     * @param {{ logoutFromEntra?: boolean }} [options]
     *   `logoutFromEntra` (default `true`): also sign out of Entra, if enabled for the stage.
     *   Pass `false` for automatic logouts so the user can sign back in silently.
     */
    async signOut(options) {
        const logoutFromEntra = options?.logoutFromEntra ?? true;

        const signOutOfCognito = async () => {
            await signOut();
            // Also clear hosted-UI cookies for sessions started without an OAuth redirect.
            this.#performSsoLogout();
        };

        if (logoutFromEntra) {
            await signOutWithEntra(config, signOutOfCognito);
        } else {
            await signOutOfCognito();
        }
    }

    // TODO: test whether it is still needed
    #performSsoLogout() {
        // config.Auth is now the Amplify v6 Auth.Cognito config. The logout URL
        // still needs the original hosted-UI metadata preserved as GMGHostedAuth.
        const logoutUrl = new URL(`https://${config.GMGHostedAuth.oauth.domain}/logout`);
        logoutUrl.searchParams.set('client_id', config.GMGHostedAuth.userPoolWebClientId);
        logoutUrl.searchParams.set('logout_uri', config.GMGHostedAuth.oauth.redirectSignOut);
        document.location = logoutUrl.toString();
    }
}

export { GMGAuth };
